import { IconSvgElement } from "@hugeicons/react";

export const Home05Icon: IconSvgElement = [
  [
    "path",
    {
      d: "M12 17H12.009",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      key: "0"
    }
  ],
  [
    "path",
    {
      d: "M20 8.5V13.5C20 17.2712 20 19.1569 18.8284 20.3284C17.6569 21.5 15.7712 21.5 12 21.5C8.22876 21.5 6.34315 21.5 5.17157 20.3284C4 19.1569 4 17.2712 4 13.5V8.5",
      stroke: "currentColor",
      strokeWidth: "1.5",
      key: "1"
    }
  ],
  [
    "path",
    {
      d: "M22 10.5L17.6569 6.33548C14.9902 3.77849 13.6569 2.5 12 2.5C10.3431 2.5 9.00981 3.77849 6.34315 6.33548L2 10.5",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      key: "2"
    }
  ]
];
